import {ReactNode} from 'react';
import {GuestsProcessingModal} from 'components/GuestRegisteringModal';
import {StatusModal, StatusModalStates} from '@chekin/shared';

type GuestCreationModalProps = {
  isOpen: boolean;
  state: StatusModalStates;
  title: string;
  successSubtitle: ReactNode;
  errorMessage: string;
  errorMessages?: string[];
  onClose: () => void;
};

export const GuestCreationModal = ({
  isOpen,
  state,
  title,
  successSubtitle,
  errorMessage,
  errorMessages,
  onClose,
}: GuestCreationModalProps) => {
  return (
    <StatusModal open={isOpen} state={state} maxWidth="350px">
      <GuestsProcessingModal
        title={title}
        state={state}
        onClose={onClose}
        errorMessage={errorMessage}
        errorMessages={errorMessages}
        successSubtitle={successSubtitle}
      />
    </StatusModal>
  );
};
